import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  breadcrumb: string;
  breadcrumbLink?: string;
  title: string;
  subtitle: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ breadcrumb, title, subtitle }) => {
  return (
    <div className="page-header">
      {/* Grid lines */}
      <div className="page-header-grid" />

      {/* Breadcrumb - just Home → */}
      <div className="breadcrumb">
        <a href="/">Home</a> <span>→</span>
      </div>

      {/* Title */}
      <h1>{title}</h1>
      
      {/* Subtitle */}
      <p>{subtitle}</p>
    </div>
  );
};

export default PageHeader;